import type { DataResponse, PaginatedResponse } from '@/core/http/services/types'
import type { Orderable, OrderableRow } from '@/core/http/services/orders/types'
import type { PromoProduct } from '@/core/http/services/promo/types'

export type VtOrder = {
  customer_id: number | null
  user_id: number
  supplier_id: number | null
  price_code: number
  discount_price: number
  discount_percentage: number
  total: number
  customer_name: string | null
  customer_address: string | null
  customer_postal_code: string | null
  customer_city: string | null
  customer_phone: string | null
  customer_mobile: string | null
  customer_email: string | null
  supplier: null
} & Orderable<VtOrderRow>

export type VtOrderRow = {
  vt_order_id: number
  promo_product_id: number | null
  total_price_discount: number
  single_price_discount: number
  quantity_free: number
  promo_product?: PromoProduct | null
} & OrderableRow

export type UpdateVtOrderRequest = {
  delivery_at: string
  comments: string
  price_code: number | null
  customer_id: number | null
  customer_name: string | null
  customer_address: string | null
  customer_postal_code: string | null
  customer_city: string | null
  customer_phone: string | null
  customer_mobile: string | null
  customer_email: string | null
  discount_price: number | null
  discount_percentage: number | null
}

export function requestFromOrder(order: VtOrder): UpdateVtOrderRequest {
  return {
    delivery_at: order.delivery_at,
    comments: order.comments,
    price_code: order.price_code,
    customer_id: order.customer_id,
    customer_name: order.customer_name,
    customer_address: order.customer_address,
    customer_postal_code: order.customer_postal_code,
    customer_city: order.customer_city,
    customer_phone: order.customer_phone,
    customer_mobile: order.customer_mobile,
    customer_email: order.customer_email,
    discount_price: order.discount_price,
    discount_percentage: order.discount_percentage,
  }
}

export type VtOrderRowRequest = {
  product_id: number
  promo_product_id: number | null
  quantity: number
  single_price_discount?: number | null
  quantity_free?: number | null
}

export type ConfirmVtOrderRequest = {
  comments: string
}

export type VtOrderPopulators = {
  price_codes: { id: number; name: string }[]
}

export type VtOrderResponse = DataResponse<VtOrder>
export type PaginatedVtOrdersResponse = PaginatedResponse<VtOrder[]>
